export enum Redirect {
    OFFSITE = 'offsite',
    ONSITE = 'onsite',
}